import React, { Component } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { Icon, ButtonV2, TooltipTrigger } from 'components';
import './style.scss';
import { withRouter } from 'react-router-dom';

class ContextMenuItem extends Component {
  static propTypes = {
    icon: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.any,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    link: PropTypes.string,
    toolTipTrigger: PropTypes.bool,
    tooltip: PropTypes.node,
    className: PropTypes.string,
    'data-cy': PropTypes.string
  };

  static defaultProps = {};

  @bind
  handleClick() {
    const { onClick, link, value, history, disabled } = this.props;
    if (disabled) {
      return;
    }
    if (onClick) {
      onClick(value);
    }
    if (link) {
      history.push(link);
    }
  }

  render() {
    const { icon, label, className, disabled, 'data-cy': dataCY, toolTipTrigger, tooltip } = this.props;
    
    const itemClassName = cx('context-menu-item', {
      'context-menu-item--disabled': disabled && !toolTipTrigger,
      'context-menu-item--disabled-with-tooltip': disabled && toolTipTrigger,
      [className]: Boolean(className),
    });

    return (
      <li className={itemClassName} onClick={this.handleClick} data-cy={dataCY}>
        {icon && <Icon name={icon} className="context-menu-item__icon" />}
        {toolTipTrigger && disabled ? (
          <div className="context-menu-item--tooltip-container">
            <span className="context-menu-item__label context-menu-item__disabled-label">
              {label}
            </span>
            <TooltipTrigger
              tooltip={tooltip}
              side="right"
              className="context-menu-item--tooltip-trigger"
            >
              <ButtonV2
                icon
                iconName="tooltip"
                iconSize={18}
                className="context-menu-item--tooltip-icon"
                onClick={e => e.stopPropagation()}
              />
            </TooltipTrigger>
          </div>
        ) : (
          <span className="context-menu-item__label">{label}</span>
        )}
      </li>
    );
  }
}

export default withRouter(ContextMenuItem);
